import { ActivatedRoute } from '@angular/router';

export function getIdFromRoute(route: ActivatedRoute, param: string): number {
    let id = route.snapshot.paramMap.get(param);
    return parseInt(id, 10) === NaN ? null : parseInt(id, 10);
}
